import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSettings, FiShare2, FiDownloadCloud, FiHeart } = FiIcons;

const steps = [
  {
    icon: FiSettings,
    title: "Create your event",
    description: "Set up your gallery in under 2 minutes. Perfect for birthdays, reunions, or corporate galas."
  },
  {
    icon: FiShare2,
    title: "Share your QR code",
    description: "Print it on invitations, table cards, or display it on the big screen during the event."
  },
  {
    icon: FiDownloadCloud,
    title: "Save & Share",
    description: "Download the entire collection in high-res or share the gallery link with everyone."
  }
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-sm font-bold text-slate-400 tracking-[0.3em] uppercase mb-4 text-center">The Memory Flow</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">Capture collective magic</h3>
          <p className="text-slate-500 text-xl font-light">Simple for you. Effortless for your guests. Unforgettable for everyone.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-12 relative">
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              className="group relative"
            >
              <div className="mb-8 relative inline-block">
                <div className="w-20 h-20 rounded-3xl bg-slate-50 flex items-center justify-center group-hover:bg-indigo-600 transition-colors duration-500 shadow-sm border border-slate-100">
                  <SafeIcon icon={step.icon} className="w-8 h-8 text-slate-800 group-hover:text-white transition-colors duration-500" />
                </div>
                <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-white shadow-lg flex items-center justify-center text-slate-900 font-bold text-sm border border-slate-100">
                  {index + 1}
                </div>
              </div>
              <h4 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h4>
              <p className="text-slate-500 leading-relaxed font-light text-lg">{step.description}</p>
              
              {index < 2 && (
                <div className="hidden lg:block absolute top-10 -right-6 text-slate-200">
                   <SafeIcon icon={FiIcons.FiChevronRight} className="w-12 h-12" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}